import { Screen } from '@/constants'

export const isLgScreen = () => window.innerWidth >= Screen.LG
